export const addError = (state, params) => {
	const { payload: error } = params;
	state.errorList = [...state.errorList, error];;
	return state;
};

export default {};